import { FC, useState, useEffect } from 'react';
import { Box, CardMedia, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { FullModalLayout } from '../layouts';
import { Media } from '../types/services/promos-api';

type MediaModalProps = {
  media: Media;
  onClose: () => void;
};

export const MediaModal: FC<MediaModalProps> = ({ media, onClose }) => {
  const { mediaType, url } = media;
  const [imageAspectRatio, setImageAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    if (mediaType === 1 && url) {
      const img = new Image();
      img.onload = () => {
        const aspectRatio = img.width / img.height;
        setImageAspectRatio(aspectRatio);
      };
      img.src = url;
    }
  }, [mediaType, url]);

  return (
    <FullModalLayout onClose={onClose} withoutBackground>
      <Typography
        variant='h4'
        paddingTop={0}
        paddingLeft={8}
        sx={{ cursor: 'pointer' }}
        onClick={onClose}
      >
        <ArrowBackIcon
          fontSize='large'
          sx={{ paddingTop: '4px', marginRight: '12px', color: '#fff' }}
        />
      </Typography>
      <Box 
        display='flex' 
        padding={2} 
        maxHeight={imageAspectRatio && imageAspectRatio <= 1.5 ? '95vh' : '90vh'}
        justifyContent='center'
        alignItems='center'
        overflow={imageAspectRatio && imageAspectRatio <= 1.5 ? 'auto' : 'hidden'}
      >
        {mediaType === 1 ? (
          <CardMedia
            component='img'
            src={url}
            sx={{
              paddingTop: imageAspectRatio && imageAspectRatio <= 1.5 ? 0.5 : 1,
              paddingBottom: imageAspectRatio && imageAspectRatio <= 1.5 ? 0.5 : 1,
              maxWidth: '100%',
              maxHeight: imageAspectRatio && imageAspectRatio <= 1.5 ? 'none' : '100%',
              width: 'auto',
              height: 'auto',
              objectFit: imageAspectRatio && imageAspectRatio > 1.5 ? 'cover' : 'contain',
              display: 'block',
              margin: '0 auto',
            }}
          />
        ) : (
          <CardMedia
            component='video'
            controls={true}
            src={url}
            sx={{
              margin: '0 auto',
              maxWidth: '100%',
              maxHeight: '100%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        )}
      </Box>
    </FullModalLayout>
  );
};
